app.service('accountInvoicesView', function (console, validate, modal, account, vies, regon, message, companyName, loading, accountConfig, accountEntityInvoices, addressIntegrityValidator, broker) {
	let $self;
	let config, frontUserType;

	function setElements() {
		$self = $('#invoice-address-box');
	}

	function setEvents() {
		$self.on('click', '.js-invoice-cancel', function () {
			cancel($(this).data('id'));
		}).on('click', '.js-invoice-add', function () {
			$('#entity-invoice-data-0').empty();
			load();
		})
		.on('click', '.js-invoice-remove', function () {
			confirmDeleteAddress($(this).data('id'));
		}).on('click', '.js-invoice-edit', function () {
			load($(this).data('id'));
		}).on('click', '.js-invoice-set-default', function () {
			setDefaultInvoiceAddress($(this).data('id'))
		}).on('click', '.js-invoice-save', function () {

		})

	}

	function cancel(addressId = 0) {
		let $div = $('#invoice-data-' + addressId);
		$div.empty();
	}

	function load(addressId = 0) {
		console.log('ŁADOWANIE ADRESU FAKTURY - ' + addressId);
		let data = {};
		if (addressId) {
			data.invoiceDataId = addressId;
			console.log('ŁADOWANIE DANYCH DO FAKTURY - ' + addressId);
		} else {
			console.log('ŁADOWANIE NOWYCH DANYCH DO FAKTURY');
		}
		loading.start();
		$.ajax({
			url: '/customer-invoice-data-edit.ltr',
			cache: false,
			data: data,
			success: function (content) {
				loading.stop();
				generate(addressId, content);
			},
			error: function () {
				loading.stop();
				loadError();
			}
		});
	}

	function loadError() {
		modal.alert('Wystąpił bład pobierania danych do faktury. Spróbuj ponownie później');
		console.log('ŁADOWANIE ADRESU DOSTAWY - ERROR');
	}

	function generate(addressId, content) {
		let $div = $('#invoice-data-' + addressId);
		$div.html(content);
		let $form = $div.find('form');
		var $countryUe = $('#country-ue-' + addressId);
		var $countryId = $('#country-id-' + addressId);
		var $vatUe = $('#vat-ue-' + addressId);
		var $nip = $('#nip-' + addressId);
		var $companyName = $('#company-name-' + addressId + 'textarea');
		var $addressBox = $('.address-form', $div);
		var $taxIdTypeBoxes = $addressBox.find('.tax-id-type-box');
		let taxIdType = $taxIdTypeBoxes.filter('.active').data('type') || "NIP";
		let $idNumber = $idNumber = $('#id-number-' + addressId);
		let $country = $(`#country-code-${addressId}`);
		let $zipCode = $('#zip-code-' + addressId);
		let $city = $('#city-name-' + addressId);
		let $street = $('#street-' + addressId);
		let $toggleTaxPayerRoleJst = $(`#toggle-tax-payer-role-jst-${addressId}`);
		let $toggleTaxPayerRoleGrv = $(`#toggle-tax-payer-role-grv-${addressId}`);

		$toggleTaxPayerRoleJst.on('change', function handleToggleTaxPayerRoleJstChange() {
			const checked = $(this).is(':checked');
			$(this).closest('.tax-payer-role').toggleClass('is-active');
			$toggleTaxPayerRoleGrv.prop('disabled', checked)
				.closest('.tax-payer-role')
				.toggleClass('is-disabled', checked);
		});

		$toggleTaxPayerRoleGrv.on('change', function handleToggleTaxPayerRoleGrvChange() {
			const checked = $(this).is(':checked');
			$(this).closest('.tax-payer-role').toggleClass('is-active');
			$toggleTaxPayerRoleJst.prop('disabled', checked)
				.closest('.tax-payer-role')
				.toggleClass('is-disabled', checked);
		});

		$('.select3-input', $div).select3();
		validate.task('invoice', {
			$form,
			send: function () {

				loading.start();

				if ($country.val() !== 'PL') {
					send($form, addressId);
					return;
				}

				addressIntegrityValidator.validate({
					data: {
						invoiceCityName: $city.val(),
						invoiceZipCode: $zipCode.val(),
						invoiceAddressStreet: $street.val(),
						isInvoice: true
					},
					onSuccess: () => send($form, addressId)
				});
			}
		});

		$country.on('change', function () {
			if ($zipCode.val().length) {
				$form.validate().element($zipCode);
			}

			if ($country.val() === 'PL') {
				autocompleteDelivery(`zip-code-${addressId}`, `city-name-${addressId}`, `street-${addressId}`);
				$zipCode.mask2("99-999");
			} else {
				unautocompleteDelivery(`zip-code-${addressId}`, `city-name-${addressId}`, `street-${addressId}`);
				$zipCode.unmask2("99-999");
			}

			setZipCode($country.val());

			if (hasChangedPolishCountryCode($country)) {
				$(`#zip-code-${addressId}, #city-name-${addressId}, #street-${addressId}, #house-number-${addressId}, #flat-number-${addressId}`).val(''); // czyścimy dane adresowe
			}

			$(this).data('prev-value', $(this).val());
		});

		if ($country.val() === 'PL') {
			$zipCode.mask2("99-999");
			autocompleteDelivery(`zip-code-${addressId}`, `city-name-${addressId}`, `street-${addressId}`);
		}

		$(`#id-number-${addressId}-div`).on('input', function() {
			$idNumber.val($(this).text());
			$form.validate().element($idNumber);
		});

		companyName.init('company-name-' + addressId);
		regon.init({
			$country: $country,
			$box: $('#invoice-data-' + addressId + ' .regon-box'),
			$nip: $('#nip-' + addressId),
			$companyName: $('#company-name-' + addressId + '-textarea-div'),
			$city: $('#city-name-' + addressId),
			$street: $('#street-' + addressId),
			$houseNumber: $('#house-number-' + addressId),
			$flatNumber: $('#flat-number-' + addressId),
			$zipCode: $zipCode
		});

		vies.init({
			$box: $('#invoice-data-' + addressId + ' .vies-box'),
			$button: $('#invoice-data-' + addressId + ' .js-vies-button'),
			$vatNumber: $vatUe,
			$country: $countryUe,
			$taxIdSelector: $self.find('#tax-identifier-selector-' + addressId),
			nipEuValidate: config.nipEuValidate,
			validatedVatUeNumbers: config.validatedVatUeNumbers,
			onVatUeValidationUpdated: triggerVatUeValidation
		});

		broker.on('VIES_VERIFICATION_FINISHED', function (event, result) {
			if (result.success) {
				updateValidatedVatUeNumbersConfig(result.countryCode, result.vatUeNumber);
				triggerVatUeValidation();
			}
		});

		function updateValidatedVatUeNumbersConfig(countryCode, vatUeNumber) {
			if (!config.validatedVatUeNumbers.some(entry => entry[countryCode] && entry[countryCode].includes(vatUeNumber))) {
				config.validatedVatUeNumbers.push({[countryCode]: [vatUeNumber]});
			}
		}

		$countryId.on('change', function () {
			$form.validate().element($countryId);
		});
		$self.on('change', '#tax-identifier-selector-' + addressId, function handleTaxIdentifierChange() {
			taxIdType = $(this).val();

			$countryId.val('').trigger('change');
			$countryUe.val('').trigger('change');

			setTaxIdTypeBox();
		});

		function hasChangedPolishCountryCode($countryCode) {
			const previousValue = $countryCode.data('prev-value');
			const currentValue = $countryCode.val();

			if (previousValue === 'PL' && currentValue !== 'PL') {
				return true;
			}

			return previousValue !== 'PL' && currentValue === 'PL';
		}

		function setZipCode(countryCode) {
			const isPolishCountryCode = countryCode === 'PL';
			const maxLength = isPolishCountryCode ? 6 : 8;
			const type = isPolishCountryCode ? 'tel' : 'text';

			$zipCode.prop({
				'maxlength': maxLength,
				'type': type
			});
		}

		function triggerVatUeValidation() {
			$form.validate().element($countryUe);
			$form.validate().element($vatUe);
		}

		function setTaxIdTypeBox() {

			if (taxIdType === "") return;

			$taxIdTypeBoxes
				.removeClass('active')
				.filter((i, el) => el.dataset.type === taxIdType)
				.addClass('active');

			renderForm();
			updateValidation();
		}

		function renderForm() {

			if (taxIdType === "VAT_UE") {
				$countryId.attr('disabled', 'disabled');
				$countryUe.removeAttr('disabled');
			}

			if (taxIdType === "NUMBER_ID") {
				$countryUe.attr('disabled', 'disabled');
				$countryId.removeAttr('disabled');
			}
		}

		function updateValidation() {

			if (frontUserType === 'INDIVIDUAL') {
				ignoreAllCompanyFields();

			} else { // COMPANY
				ignoreAllCompanyFields();
				enableCompanyFieldsValidation(taxIdType);
			}
		}

		function ignoreAllCompanyFields() {
			$idNumber.ignore(true);
			$vatUe.ignore(true);
			$nip.ignore(true);
			$countryUe.ignore(true);
			$countryId.ignore(true);
			$companyName.ignore(true);
		}

		function enableCompanyFieldsValidation(type) {

			let fieldsToValidate = {
				'NIP': () => {
					$nip.ignore(false);
					$companyName.ignore(false);
				},
				'VAT_UE': () => {
					$vatUe.ignore(false);
					$companyName.ignore(false);
					$countryUe.ignore(false);
				},
				'NUMBER_ID': () => {
					$idNumber.ignore(false);
					$companyName.ignore(false);
					$countryId.ignore(false);
				},
				'EMPTY_ID': () => {
					$companyName.ignore(false);
				}
			}

			return fieldsToValidate[type]();
		}
	}

	function send($form, addressId) {
		if (account.isFrontUserLogged()) {
			loading.start();
			$form.ajaxSubmit({
				success: function (html) {
					loading.stop();
					sendSuccess(addressId, html);
				},
				error: function () {
					loading.stop();
					modal.alert('Wystąpił błąd zapisu danych do faktury. Spróbuj ponownie później');
				}
			});
		}
	}

	function sendSuccess(addressId, html) {
		generate(addressId, html);
		if ($(html).filter('.success').length) {		//mamy powodzenie
			loading.reload();
		}
	}

	function confirmDeleteAddress(addressId) {
		console.log('POTWIERDZENIE USUNIĘCIA ADRESU - ' + addressId);
		modal.generate({
			header: 'Czy na pewno chcesz usunąć dane?',
			id: 'delete-address',
			buttons: [
				{
					text: 'Tak',
					cssClass: 'button-remove-address',
					click: function () {
						modal.close();
						deleteAddress(addressId);
					}
				},
				{
					text: 'Anuluj',
					cssClass: 'button-cancel',
					click: function () {
						modal.close();
					}
				}
			]
		});
	}

	function deleteAddress(addressId) {
		loading.start();
		$.ajax({
			url: '/customer-remove-invoice-address.ltr',
			type: 'POST',
			cache: false,
			data: {
				addressId: addressId
			},
			success: function () {
				loading.reload();
			},
			error: function () {
				modal.alert('Błąd usuwania adresu. Spróbuj ponownie później', function () {
					loading.reload();
				});
			}
		});
	}

	function setDefaultInvoiceAddress(addressId) {
		loading.start();
		$.ajax({
			url: '/customer-set-default-invoice-address.ltr',
			type: 'POST',
			cache: false,
			data: {
				addressId: addressId
			},
			success: function () {
				loading.reload();
			},
			error: function () {
				modal.alert('Błąd ustawiania adresu domyślnego. Spróbuj ponownie później', function () {
					loading.reload();
				});
			}
		});
	}

	function loadSubscriptionInvoiceMessage() {
		var $box = $('#subscription-invoice-message');
		if ($box.length) {
			$.ajax({
				url: '/customer-subscription-service-contract-activity.ltr',
				type: 'GET',
				success: function (hasAnyActiveSubscription) {
					if (hasAnyActiveSubscription) {
						$box.removeAttr('hidden');
					}
				}
			});
		}
	}

	function init() {

		config = accountConfig.getData();
		frontUserType = config.frontUserType;

		setElements();
		setEvents();
		loadSubscriptionInvoiceMessage();

		accountEntityInvoices.init();
	}

	return {
		init
	};
});
